import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-confirmation/actions/initialize';
export default {
    initialize,
};